import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SgDialogComponent } from './sg-dialog.component';
import { SgDialogData, SgDialogResult } from './sg-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class SgDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: SgDialogData, dialogConfig?: Partial<MatDialogConfig>): MatDialogRef<SgDialogComponent, string> {
    return this.dialog.open(SgDialogComponent, {
      data,
      disableClose: false,
      autoFocus: false,
      restoreFocus: true,
      panelClass: 'sg-ui-component',
      ...dialogConfig,
    });
  }

  confirm(
    dialogData: Partial<SgDialogData>,
    dialogConfig?: Partial<MatDialogConfig>
  ): Observable<SgDialogResult | undefined> {
    const defaults: Partial<SgDialogData> = {
      icon: 'warning',
      iconColor: '--sg-content-warning-primary',
      showCloseButton: true,
      okButton: {
        text: 'OK',
        variant: 'primary',
        icon: 'check',
        iconPosition: 'start',
      },
      cancelButton: {
        text: 'Cancel',
        variant: 'ghost-primary',
        icon: 'close',
        iconPosition: 'start',
      },
    };

    // Merge defaults with provided data
    const data = {
      ...defaults,
      ...dialogData,
      // Preserve deep merge for buttons if partially provided
      okButton: dialogData.okButton ? { ...defaults.okButton, ...dialogData.okButton } : defaults.okButton,
      cancelButton: dialogData.cancelButton
        ? { ...defaults.cancelButton, ...dialogData.cancelButton }
        : defaults.cancelButton,
    } as SgDialogData;

    const dialogRef = this.dialog.open(SgDialogComponent, {
      data,
      disableClose: true,
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      panelClass: 'sg-ui-component',
      ...dialogConfig,
    });

    return dialogRef.afterClosed();
  }

  alert(
    title: string,
    description?: string,
    buttonText = 'OK',
    icon = 'info',
    dialogConfig?: Partial<MatDialogConfig>
  ): Observable<string | undefined> {
    const dialogRef = this.open(
      {
        title,
        description,
        icon,
        okButton: {
          text: buttonText,
          variant: 'primary',
        },
      },
      dialogConfig
    );

    return dialogRef.afterClosed();
  }
}
